const SOCIAL_DESCRIPTION = `Overall Social scores out of 100, and then broken down by Product Responsibility, Community Engagement, Human Rights and Workforce. The higher the score the better.`;

export default SOCIAL_DESCRIPTION;
